(function () {
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // dropdown menu
  var toggle = $('[data-menu-toggle]');
  var menu = $('#site-menu');
  function setMenu(open) {
    if (!toggle || !menu) return;
    menu.hidden = !open;
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'close menu' : 'open menu');
  }
  if (toggle) toggle.addEventListener('click', function (e) { e.stopPropagation(); setMenu(menu.hidden); });
  document.addEventListener('click', function (e) {
    if (menu && !menu.hidden && !menu.contains(e.target)) setMenu(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && !menu.hidden) { setMenu(false); toggle.focus(); }
  });

  // search panel
  var panel = $('#search-panel');
  function setSearch(open) {
    if (!panel) return;
    panel.hidden = !open;
    $$('[data-search-open]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    if (open) { setMenu(false); var q = $('#q'); if (q) q.focus(); }
  }
  $$('[data-search-open]').forEach(function (b) { b.addEventListener('click', function () { setSearch(true); }); });
  $$('[data-search-close]').forEach(function (b) { b.addEventListener('click', function () { setSearch(false); }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel && !panel.hidden) setSearch(false); });

  // collection filters
  var shop = $('[data-shop]');
  if (shop) {
    var grid = $('[data-grid]', shop);
    var cards = $$('.card', grid);
    var empty = $('[data-empty]', shop);
    var count = $('[data-count]', shop);
    var vendor = 'all', hideSold = false;
    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = (vendor === 'all' || c.dataset.vendor === vendor) && !(hideSold && c.dataset.status === 'sold');
        c.hidden = !ok; if (ok) n++;
      });
      if (count) count.textContent = n + (n === 1 ? ' piece' : ' pieces');
      if (empty) empty.hidden = n > 0 || cards.length === 0;
      $$('.chip', shop).forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.vendorFilter === vendor)); });
    }
    $$('[data-vendor-filter]', shop).forEach(function (b) {
      b.addEventListener('click', function () { vendor = b.dataset.vendorFilter; apply(); });
    });
    var hs = $('[data-hide-sold]', shop);
    if (hs) hs.addEventListener('change', function () { hideSold = hs.checked; apply(); });
    $$('[data-view]', shop).forEach(function (b) {
      b.addEventListener('click', function () {
        grid.classList.toggle('is-list', b.dataset.view === 'list');
        $$('[data-view]', shop).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
      });
    });
    apply();
  }

  // product gallery
  $$('[data-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var i = t.dataset.thumb;
      $$('[data-slide]').forEach(function (s) { s.hidden = s.dataset.slide !== i; });
      $$('[data-thumb]').forEach(function (x) { x.setAttribute('aria-pressed', String(x === t)); });
    });
  });
})();
